// extracted by mini-css-extract-plugin
module.exports = {"tabs-container":"tabs-container--3suhb_l_5M","tabsContainer":"tabs-container--3suhb_l_5M"};